import './App.css';
import First_page from '../src/compo/first_page/home';

function App() {
  return (
    <div>
        <First_page />
    </div>
  );
}

export default App;
